import { useState } from "react";
import Link from "react-scroll/modules/components/Link";
import styled from "styled-components";
import { mobileMinWidth, colors, fonts, radii, transitions } from "../theme";

const Wrapper = styled.div`
  display: flex;
  align-items: center;

  @media screen and (min-width: ${mobileMinWidth}) {
    display: none;
  }
`;

const Overlay = styled.div<{ open: boolean }>`
  position: fixed;
  inset: 0;
  background: rgba(11, 18, 32, 0.4);
  opacity: ${({ open }) => (open ? 1 : 0)};
  pointer-events: ${({ open }) => (open ? "auto" : "none")};
  transition: opacity 0.3s ease;
  z-index: 0;
`;

const StyledMenu = styled.nav<{ open: boolean }>`
  position: fixed;
  top: 88px;
  left: 16px;
  right: 16px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  background: ${colors.surface};
  border-radius: ${radii.large};
  box-shadow: ${colors.shadowHeavy};
  z-index: 1;
  opacity: ${({ open }) => (open ? 1 : 0)};
  transform: ${({ open }) =>
    open ? "translateY(0) scale(1)" : "translateY(-8px) scale(0.98)"};
  transform-origin: top center;
  pointer-events: ${({ open }) => (open ? "auto" : "none")};
  transition: opacity 0.25s ease, transform 0.3s cubic-bezier(0.22, 1, 0.36, 1);
`;

const Hamburger = styled.button<{ open: boolean; activeheader: boolean }>`
  width: 44px;
  height: 44px;
  padding: 0 12px;
  border-radius: ${radii.round};
  background: ${(props) =>
    props.activeheader ? colors.surfaceMuted : "rgba(255, 255, 255, 0.1)"};
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 5px;
  border: none;
  cursor: pointer;
  z-index: 1;

  div {
    width: 20px;
    height: 2px;
    border-radius: 2px;
    background-color: ${(props) =>
      props.activeheader ? colors.ink : colors.white};
    transition: all 0.3s ease;
    transform-origin: center;

    :first-child {
      transform: ${({ open }) =>
        open ? "translateY(7px) rotate(45deg)" : "none"};
    }
    :nth-child(2) {
      opacity: ${({ open }) => (open ? "0" : "1")};
    }
    :nth-child(3) {
      transform: ${({ open }) =>
        open ? "translateY(-7px) rotate(-45deg)" : "none"};
    }
  }
`;

const RowItem = styled.span`
  display: block;
  padding: 16px 20px;
  border-radius: ${radii.medium};
  color: ${colors.ink};
  font-family: ${fonts.heading};
  font-weight: 600;
  font-size: 18px;
  cursor: pointer;
  transition: ${transitions.fast};

  &:hover {
    background: ${colors.surfaceMuted};
  }
`;

type props = {
  activeHeader: boolean;
};

const MobileMenu = ({ activeHeader }: props) => {
  const [open, setOpen] = useState<boolean>(false);
  return (
    <Wrapper>
      <Overlay open={open} onClick={() => setOpen(false)} />
      <StyledMenu open={open} aria-hidden={!open}>
        <Link
          to="home"
          smooth={true}
          offset={-100}
          duration={400}
          onClick={() => setOpen(false)}
        >
          <RowItem>Hem</RowItem>
        </Link>

        <Link
          to="ourProjects"
          smooth={true}
          offset={-100}
          duration={400}
          onClick={() => setOpen(false)}
        >
          <RowItem>Våra appar</RowItem>
        </Link>

        <Link
          to="contact"
          smooth={true}
          offset={-100}
          duration={400}
          onClick={() => setOpen(false)}
        >
          <RowItem>Kontakt</RowItem>
        </Link>
      </StyledMenu>
      <Hamburger
        onClick={() => setOpen(!open)}
        open={open}
        activeheader={activeHeader || open}
        aria-label={open ? "Stäng meny" : "Öppna meny"}
        aria-expanded={open}
      >
        <div />
        <div />
        <div />
      </Hamburger>
    </Wrapper>
  );
};

export default MobileMenu;
